module.exports = __webpack_public_path__ + "static/media/aj.2c78ed2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadImg/aj.jpg
// module id = 727
// module chunks = 0